import { Controller } from "@hotwired/stimulus"
import Swal from 'sweetalert2';
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

// Connects to data-controller="bookings"
export default class extends Controller {
  connect() {
    console.log("connected to bookings controller")
    document.getElementById('message_body').value = ""

    document.getElementById('message_form').addEventListener("submit", this.clear);
    this.startCountdown();
  }

  disconnect() {
    if (this.ticker) {
      clearInterval(this.ticker);
      this.ticker = null;
    }
  }

  startCountdown() {
    const el = document.getElementById("countdown");
    if (!el) return;

    const createdAt = el.dataset.created;
    const totalSec = 60 * 60;
    const expiresAt = dayjs.utc(createdAt).add(60, 'minutes');

    const TEXT_COLORS = ['text-gray-800', 'text-amber-600', 'text-red-600'];
    const BAR_COLORS = ['bg-green-500', 'bg-amber-500', 'bg-red-500'];

    const setState = (target, bar, level) => {
      TEXT_COLORS.forEach((c) => target.classList.remove(c));
      target.classList.add(TEXT_COLORS[level]);
      if (bar) {
        BAR_COLORS.forEach((c) => bar.classList.remove(c));
        bar.classList.add(BAR_COLORS[level]);
      }
    };

    const render = () => {
      const target = document.getElementById("countdown");
      const bar = document.getElementById("countdown_progress");
      if (!target) {
        clearInterval(this.ticker);
        this.ticker = null;
        return;
      }
      const diffSec = expiresAt.diff(dayjs.utc(), 'second');
      if (diffSec <= 0) {
        target.innerHTML = "Время истекло";
        setState(target, bar, 2);
        if (bar) bar.style.width = "0%";
        clearInterval(this.ticker);
        this.ticker = null;
        const cb = document.getElementById("cancel_booking");
        if (cb) cb.classList.add('hidden');
        const cbd = document.getElementById("cancel_booking_decline");
        if (cbd) cbd.classList.remove('hidden');
        return;
      }
      const mins = Math.floor(diffSec / 60);
      const secs = diffSec % 60;
      target.innerHTML = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

      const ratio = Math.max(0, Math.min(1, diffSec / totalSec));
      if (bar) bar.style.width = `${(ratio * 100).toFixed(2)}%`;

      // color state: green > 33%, amber 10–33%, red < 10%
      const level = ratio > 0.33 ? 0 : ratio > 0.10 ? 1 : 2;
      setState(target, bar, level);
    };

    if (this.ticker) clearInterval(this.ticker);
    render();
    this.ticker = setInterval(render, 1000);
  }

  clearForm() {
    document.getElementById('message_body').value = ""
  }

  cancelBooking(event) {
    event.preventDefault()
    Swal.fire({
      title: 'Вы уверены?',
      text: "Вы не сможете отменить это действие!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да, отменить бронирование!',
      cancelButtonText: 'Отмена'
    }).then((result) => {
      if (result.isConfirmed) {
        // submit the form
        document.getElementById('cancel_booking_form').submit()
      }
    })
    // скрыть кнопку отмены
    document.getElementById("cancel_booking").classList.add('hidden');
  }
  cancelBookingManual(event) {
    event.preventDefault()
    Swal.fire({
      title: 'Вы уверены?',
      text: "Вы не сможете отменить это действие!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да, отменить бронирование!',
      cancelButtonText: 'Отмена'
    }).then((result) => {
      if (result.isConfirmed) {
        // submit the form
        document.getElementById('cancel_booking_manual_form').submit()
      }
    })
    // скрыть кнопку отмены
    document.getElementById("cancel_booking_manual").classList.add('hidden');
  }
  cancelBookingManualwithPayment(event) {
    event.preventDefault()
    Swal.fire({
      title: 'Вы уверены?',
      text: "Вы не сможете отменить это действие!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да, отменить бронирование!',
      cancelButtonText: 'Отмена'
    }).then((result) => {
      if (result.isConfirmed) {
        // submit the form
        document.getElementById('cancel_booking_manual_with_payment_form').submit()
      }
    })
    // скрыть кнопку отмены
    document.getElementById("cancel_booking_manual_with_payment").classList.add('hidden');
  }

  cancelBookingDecline(event) {
    event.preventDefault()
    Swal.fire({
      title: 'Время истекло',
      text: "К сожалению осталось меньше 7 суток до начала бронирования. Пожалуйста, свяжитесь с нами если произошла ошибка.",
      icon: 'warning',
      position: 'center',
      showConfirmButton: true,
      confirmButtonText: 'Ок',
    })
  }

  toggleReview(event) {
    event.preventDefault()
    document.getElementById('review_form').classList.toggle('hidden')
  }
  toggleReviewEdit(event) {
    event.preventDefault()
    document.getElementById('review_form_edit').classList.toggle('hidden')
  }
}
